import { openSupportChat } from '~/composables/useChatWidget';

/**
 * Contact support from a control in the app: open support chat, and when it can't open, say how
 * else to reach support.
 *
 * `openSupportChat` rejects when the widget can't be fetched and resolves false when it loaded but
 * built no chat, so both land on the same toast, which names the address that needs no widget. The
 * toast is the failure said to the member, so it is not reported (`reportFailure`), and a second
 * press fetches the widget again, since the loader drops a failed fetch.
 */
export function useContactSupport(): () => Promise<void> {
    const { showError } = useGlobalToast();

    return async function contactSupport(): Promise<void> {
        try {
            if (await openSupportChat()) return;
        } catch {
            // Said by the toast below.
        }

        showError("We couldn't open support chat", "Email support@privacybee.com and we'll sort it out.");
    };
}
